import React from 'react';
import RaiseNowPaymentButton from './raise_now_payment_button';
import Portfolio from './portfolio';
import * as CalculatorFlow from '../shared/calculator_flow';

import Myclimate from '../../assets/images/myclimate.jpg';
import Kenia from '../../assets/images/kenia.jpg';

const PORTFOLIOS = [
  {
    key: 'myclimate',
    pricePerT: { currency: 'CHF', value: 27.4 },
    image: Myclimate,
    callToActionTitle: 'Offset in international projects'
  },
  {
    key: 'Online 7137 Stove Efficient Tembea Kenya',
    pricePerT: { currency: 'CHF', value: 29.7 },
    image: Kenia,
    callToActionTitle: 'Offset in Kenia'
  }
];

export default ({ emissions, switchToPayment, displayState, paymentPortfolio }) => {
  switch(displayState) {
    case CalculatorFlow.PAYMENT:
      return (
        <Portfolio portfolio={paymentPortfolio} emissions={emissions} switchToPayment={switchToPayment} displayState={displayState} />
      );
      break;
    default:
      return (
        PORTFOLIOS.map(portfolio => (
          <Portfolio portfolio={portfolio} emissions={emissions} switchToPayment={switchToPayment} displayState={displayState} />
        ))
      )
  }
}
